import { createFileRoute } from "@tanstack/react-router";
import { EapClaimsHelp } from "./EapClaimsFAQ";

export const Route = createFileRoute("/_auth/_app/claims/help/eap")({
  component: RouteComponent,
});

function RouteComponent() {
  return <EapClaimsHelp />;
}
